import { render, staticRenderFns } from "./AnswerTypeTextfield.vue?vue&type=template&id=6d6d403e"
import script from "./AnswerTypeTextfield.vue?vue&type=script&lang=js"
export * from "./AnswerTypeTextfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports